(function () {
    'use strict';
    angular.module('SMART2').service('$focusOnField', [function () {
        return function (fields) {
            if (fields) {
                var field = $(fields);
            if (field.attr('type') == "checkbox" || field.attr('type') == "radio") {
                field.focus().addClass('tabbed');
            } else {
                field.focus()
            }
            }
        };
}])
})();
